export default __webpack_public_path__ + "static/media/SilverCard.e06d5b18.png";